export default __webpack_public_path__ + "scripts/resources/assignments/en/oracle-temp-3/reactions.json";